<ng-container *transloco="let t">
  @if (hasDspAdvertiser() === false) {
    <div class="px-4">
      <IAlert type="warning">{{ t("amc.strategy_analysis_no_dsp_advertiser") }}</IAlert>
    </div>
  } @else if (analyses()) {
    <IDataTable [datasource]="dataSource" [showTextFilter]="!strategyId()">
      <button
        iButton
        iDataTableSuffix
        [routerLink]="strategyId() ? 'advanced-analysis' : 'new'"
        queryParamsHandling="merge"
        [disabled]="readOnly()"
      >
        <IIcon name="plus" />{{ t("amc.strategy_analysis_new") }}
      </button>
      <table iTable>
        <thead iTableHead>
          <tr>
            @if (!strategyId()) {
              <th iTableTh>{{ t("common.strategy") }}</th>
            }
            <th iTableTh>{{ t("common.period") }}</th>
            <th iTableTh>{{ t("amc.strategy_analysis_templates") }}</th>
            <th iTableTh>{{ t("common.status") }}</th>
            <th iTableTh></th>
          </tr>
        </thead>
        <tbody iTableBody>
          @for (analysis of dataSource.data(); track analysis.analysisId) {
            <tr iTableRow>
              @if (!strategyId()) {
                <td iTableTd>
                  @for (strategyId of analysis.strategyIds; track strategyId) {
                    <app-strategy-link [strategyId]="strategyId" [withCampaignState]="false" />
                  }
                </td>
              }
              <td iTableTd>
                {{ analysis.startDate | date: "mediumDate" : undefined : locale() }} –
                {{ analysis.endDate | date: "mediumDate" : undefined : locale() }}
              </td>
              <td iTableTd>
                <button
                  type="button"
                  class="flex cursor-pointer flex-wrap gap-1"
                  (click)="openTemplatesModal(analysis)"
                >
                  @for (request of analysis.requests; track request.requestId; let i = $index) {
                    @if (i < 2) {
                      <IBadge [label]="t('amc-analysis-template.' + request.template)" color="gray" />
                    }
                  }
                  @if (analysis.requests.length > 2) {
                    <IBadge [label]="'+ ' + (analysis.requests.length - 2)" color="gray" variant="solid" />
                  }
                </button>
              </td>
              <td iTableTd>
                <IBadge
                  [label]="t('status.' + analysis.status)"
                  [color]="STATUS_COLORS[analysis.status]"
                  variant="soft"
                />
              </td>
              <td iTableTd class="text-right">
                @if (analysis.status === AmcAnalysisStatus.FAILED) {
                  @for (request of analysis.requests; track request.requestId) {
                    @if (request.failureReason) {
                      <div class="type-caption text-muted-foreground">
                        {{ t("amc-analysis-failure." + request.failureReason) }}
                      </div>
                    }
                  }
                } @else {
                  <button
                    iButton
                    variant="secondary"
                    [disabled]="analysis.status !== AmcAnalysisStatus.READY"
                    [loading]="downloadingRequestIds().has(analysis.analysisId)"
                    (click)="download(analysis)"
                  >
                    <IIcon name="import" />{{ t("common.download") }}
                  </button>
                }
              </td>
            </tr>
          } @empty {
            <tr iTableRow>
              <td iTableTd colspan="5" class="text-center">{{ t("amc.strategy_analysis_empty") }}</td>
            </tr>
          }
        </tbody>
      </table>
    </IDataTable>
  } @else {
    <div class="flex justify-center py-12">
      <ISpinner />
    </div>
  }

  <ng-template #templatesModal>
    <ul class="m-0 flex list-none flex-col divide-y p-0">
      @for (request of templatesModalRequests(); track request.requestId) {
        <li class="flex flex-col gap-1 py-3 first:pt-0 last:pb-0">
          <span class="type-body-medium">{{ t("amc-analysis-template." + request.template) }}</span>
          <span class="type-label text-muted-foreground">
            {{ t("amc-analysis-template." + request.template + "_DESCRIPTION") }}
          </span>
        </li>
      }
    </ul>
  </ng-template>
</ng-container>
